import { useEffect, useState } from 'react'

import { Form, Modal } from 'react-bootstrap'
import { Coin, XCircleFill } from 'react-bootstrap-icons'

import { CustomButton } from '../../../components/CustomButton'
import { CustomPriceInput } from '../../../components/CustomPriceInput'
import LeroyMerlinService from '../../../services/database/LeroyMerlinService'

import { toast } from 'react-toastify'

import { adaptValue } from '../../../utils/adaptValue'

import styles from './styles.module.css'

export function ModalEnviarOfertasLeroy({ isOpen, product, onClose }) {
  const [accounts, setAccounts] = useState([])
  const [isAccountsLoading, setIsAccountsLoading] = useState(true)
  const [selectedAccountKey, setSelectedAccountKey] = useState('')

  const [quantity, setQuantity] = useState('')
  const [price, setPrice] = useState('')
  const [isAddDiscount, setIsAddDiscount] = useState(false)

  const [startDateDiscount, setStartDateDiscount] = useState('')
  const [endDateDiscount, setEndDateDiscount] = useState('')
  const [discountPrice, setDiscountPrice] = useState('')

  const [isRequestLoading, setIsRequestLoading] = useState(false)

  const [importId, setImportId] = useState('')

  const isButtonEnable =
    !selectedAccountKey ||
    !quantity ||
    !price ||
    (isAddDiscount && startDateDiscount && (!endDateDiscount || !discountPrice))

  async function handleSubmit() {
    setIsRequestLoading(true)

    try {
      const priceFormatted = adaptValue(price)

      let data = {
        product_sku: product.SKU,
        quantity,
        price: priceFormatted,
        isAddDiscount,
      }

      if (isAddDiscount) {
        const startDateDiscountFormatted = new Date(
          startDateDiscount,
        ).toISOString()
        const endDateDiscountFormatted = new Date(endDateDiscount).toISOString()
        const discountPriceFormatted = adaptValue(discountPrice)

        data = {
          ...data,
          startDateDiscount: startDateDiscountFormatted,
          endDateDiscount: endDateDiscountFormatted,
          discountPrice: discountPriceFormatted,
        }
      }

      console.log({
        data,
      })

      const importIdData = await LeroyMerlinService.sendOffer(
        data,
        selectedAccountKey,
      )

      setImportId(importIdData)

      toast.success('Oferta enviada com sucesso!')

      clearStates()
    } catch (err) {
      console.log(`Erro ao mandar a oferta: ${err}`)

      toast.error(`Erro ao mandar a oferta!`)
    } finally {
      setIsRequestLoading(false)
    }
  }

  function clearStates() {
    setQuantity('')
    setPrice('')
    setIsAddDiscount(false)
    setStartDateDiscount('')
    setEndDateDiscount('')
    setDiscountPrice('')
    setSelectedAccountKey('')
  }

  function handleClose() {
    clearStates()

    onClose()
  }

  async function getAccounts() {
    setIsAccountsLoading(true)

    try {
      const accountsData = await LeroyMerlinService.getAccounts()

      setAccounts(accountsData)
    } catch (err) {
      console.log(err)

      toast.error('Erro ao carregar ')
    } finally {
      setIsAccountsLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      getAccounts()
    }
  }, [isOpen])

  return (
    <Modal
      centered
      show={isOpen}
      onHide={handleClose}
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Enviar Ofertas para Leroy</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Label>Selecione sua conta da Leroy:</Form.Label>

        <Form.Select
          className="mb-2"
          value={selectedAccountKey}
          disabled={isAccountsLoading}
          onChange={(e) => {
            setSelectedAccountKey(e.target.value)
          }}
        >
          <option value="">
            {isAccountsLoading ? 'Carregando contas...' : 'Selecione sua conta'}
          </option>

          {accounts.map((account) => (
            <option
              key={Math.random()}
              value={account.TOKEN}
            >
              {account.NOME_CONTA}
            </option>
          ))}
        </Form.Select>

        <div className={styles.productContainer}>
          <p>
            Produto: <strong>{product.SKU}</strong> - {product.DESCRICAO}
          </p>

          <section className={styles.formRequest}>
            <article>
              <Form.Label>Quantidade</Form.Label>

              <Form.Control
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
            </article>

            <article>
              <Form.Label>Preço</Form.Label>

              <CustomPriceInput
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </article>
          </section>

          <Form.Check
            label="Adicionar Desconto"
            checked={isAddDiscount}
            style={{
              margin: '20px 0',
            }}
            onChange={() =>
              isAddDiscount ? setIsAddDiscount(false) : setIsAddDiscount(true)
            }
          />

          {isAddDiscount && (
            <section className={styles.formRequest}>
              <article>
                <Form.Label>Início do desconto</Form.Label>

                <Form.Control
                  type="datetime-local"
                  value={startDateDiscount}
                  onChange={(e) => setStartDateDiscount(e.target.value)}
                />
              </article>

              <article>
                <Form.Label>Fim do desconto</Form.Label>

                <Form.Control
                  type="datetime-local"
                  value={endDateDiscount}
                  onChange={(e) => setEndDateDiscount(e.target.value)}
                />
              </article>

              <article>
                <Form.Label>Preço Desconto</Form.Label>

                <CustomPriceInput
                  value={discountPrice}
                  onChange={(e) => setDiscountPrice(e.target.value)}
                />
              </article>
            </section>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {importId && (
          <p>
            Código da importação: <strong>{importId}</strong>
          </p>
        )}

        <div
          style={{
            display: 'flex',
          }}
        >
          <CustomButton
            isLoading={isRequestLoading}
            isDisabled={isButtonEnable}
            title="Enviar"
            color="#11700b"
            onClick={handleSubmit}
          >
            <Coin />
          </CustomButton>

          <CustomButton
            title="Cancelar"
            color="#d30505"
            onClick={handleClose}
          >
            <XCircleFill />
          </CustomButton>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
